<template>
  <div>
    <form action="#" id="contactVendor" @submit.prevent="submitForm">
      <div class="mt-0 text-lg mb-2">{{ lang.headline }}</div>

      <!-- Show info about previous emails -->
      <div
        class="alert alert-warning"
        role="alert"
        v-if="showLastContacted"
        v-html="lastContacted"
      ></div>

      <div
        class="form-group"
        :class="{
          'has-error': formErrors.has('msg'),
          errorShake: formErrors.has('msg') && shakeOnError,
        }"
      >
        <input-textarea
          v-model="msg"
          name="msg"
          @focus="checkUserLogin"
          :disabled="disableForm"
          required
          :label="lang.labels.message"
        ></input-textarea>

        <div class="text-sm text-gray-600" v-if="!guest">
          {{ lang.msg.email_will_be_added_to_msg }}
        </div>
      </div>

      <div class="mt-4 flex justify-end">
        <plain-button color="primary" buttonType="submit">
          <span v-show="!showConfirmation">{{ lang.labels.send }}</span
          ><span v-show="showConfirmation"><i class="fas fa-check"></i></span>
        </plain-button>
      </div>
    </form>

    <modal-master-guest ref="modalMasterGuest"></modal-master-guest>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import FormErrors from "./../../FormErrors.js";
import ModalMasterGuest from "../modal/ModalMasterGuest.vue";

const props = defineProps({
  lang: Object,
  guest: Boolean,
  profilePage: Object,
  lastContacted: {
    type: String,
    default: "",
  },
});

const modalMasterGuest = ref(null);

const msg = ref("");
const disableForm = ref(false);
const showConfirmation = ref(false);
const shakeOnError = ref(true);
const formErrors = ref(new FormErrors());

const showLastContacted = computed(() => props.lastContacted !== "");

const checkUserLogin = () => {
  if (props.guest) {
    loadRegisterModal();
    return false;
  }
  return true;
};

const loadRegisterModal = () => {
  const modalData = {
    modalTrigger: "contactVendor",
  };
  modalMasterGuest.value.loadModal("guestRegister", modalData);
};

const submitForm = () => {
  if (!checkUserLogin()) {
    return;
  }

  disableForm.value = true;
  const validation = validateForm();

  if (validation) {
    axios
      .post(`/web-api/profile-page/${props.profilePage.id}/msg`, {
        msg: msg.value,
      })
      .then((response) => {
        showConfirmation.value = true;
      })
      .catch((error) => {
        disableForm.value = false;
      });
  } else {
    disableForm.value = false;
  }
};

const validateForm = () => {
  formErrors.value.clear();
  shakeOnError.value = true;
  const errors = {};

  if (msg.value === "" || msg.value === null) {
    errors.msg = "missing";
  }

  formErrors.value.record(errors);

  if (formErrors.value.any()) {
    setTimeout(() => {
      shakeOnError.value = false;
    }, 500);
    return false;
  }

  return true;
};
</script>
